import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Row, Col } from 'react-bootstrap';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateDocument = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    number: '',
    date: new Date().toISOString().split('T')[0],
    customerName: '',
    companyName: '',
    details: '',
    customerId: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.number || !formData.customerName) {
      toast.error('Заполните обязательные поля');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        customerId: formData.customerId ? parseInt(formData.customerId) : null,
      };
      await apiRequests.documents.create(payload);
      toast.success('Документ создан');
      navigate('/documents');
    } catch (e) {
      console.error('Ошибка создания документа:', e);
      toast.error('Ошибка при создании документа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormLayout
      onSubmit={handleSubmit}
      onBack={() => navigate('/documents')}
      saving={loading}
      submitText="Создать документ"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Номер документа" required>
              <Form.Control
                type="text"
                name="number"
                value={formData.number}
                onChange={handleChange}
                placeholder="Введите номер документа"
              />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Дата" required>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </FormField>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormField label="Имя клиента" required>
              <Form.Control
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder="Введите имя клиента"
              />
            </FormField>
          </Col>
          <Col md={6}>
            <FormField label="Название компании">
              <Form.Control
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Опционально"
              />
            </FormField>
          </Col>
        </Row>

        <FormField label="ID клиента" hint="Укажите ID пользователя для привязки документа к клиенту">
          <Form.Control
            type="number"
            name="customerId"
            value={formData.customerId}
            onChange={handleChange}
            placeholder="Опционально"
            style={{ maxWidth: '200px' }}
          />
        </FormField>

        <FormField label="Детали">
          <Form.Control
            as="textarea"
            rows={4}
            name="details"
            value={formData.details}
            onChange={handleChange}
            placeholder="Введите дополнительные детали"
          />
        </FormField>
      </FormSection>
    </FormLayout>
  );
};

export default CreateDocument;
